import { useSelector } from 'react-redux';
import { Icon, Table, Text } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import PropertyOrDevelopmentCell from '../components/PropertyOrDevelopmentCell';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';

export default function InquiriesReceivedTableRow({ inquiry }) {
  const isAdmin = useSelector(
    (state) => state.AuthSlice.permissions.is_company_admin
  );
  const {
    id,
    property,
    operation,
    property_type,
    contact,
    assigned_agent,
    origin,
    entry_date,
    entry_time,
  } = inquiry;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <PropertyOrDevelopmentCell
          id={property?.id}
          thumbnail={property?.thumbnail}
          address={property?.address}
          location={property?.location}
          modal="inquiriesReceived"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        {operation || property_type ? (
          <>
            {operation && <Text variant="body.fontSize13">{operation}</Text>}
            {property_type && (
              <Text variant="body.fontSize13">{property_type}</Text>
            )}
          </>
        ) : (
          <Icon icon="icon-mostrarmenos" />
        )}
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          highlighted={false}
          id={contact?.id}
          cellphone={contact?.cellphone}
          name={contact?.name}
          email={contact?.email}
          image={contact?.image}
          agent={assigned_agent}
          leadStatus={contact?.lead_status}
          relativeSelector="#inquiries-received-modal"
          modal="inquiriesReceived"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{origin}</Text>
      </Table.RowItemDefault>

      {isAdmin && (
        <Table.RowItemDefault
          variant="secondary"
          className={styles.tableBodyCell}
        >
          <AgentBranchCell
            agentId={assigned_agent?.id}
            agentName={assigned_agent?.name}
            branchName={assigned_agent?.branch_name}
            image={assigned_agent?.profile_picture}
            relativeSelector="#inquiries-received-modal"
            modal="inquiriesReceived"
          />
        </Table.RowItemDefault>
      )}

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">{entry_date}</Text>
        <Text variant="body.fontSize13">{`${entry_time} hs`}</Text>
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
